import React from 'react';
import { Reference } from '@/actions/directus';
import Image from 'next/image';

interface ReferenceCardProps {
  reference: Reference;
}

const ReferenceCard: React.FC<ReferenceCardProps> = ({ reference }) => {
  if (!reference) {
    return null;
  }
  return (
    <div className="card rounded-lg bg-base-200 p-2">
      <div className="card-body">
        <p className="text-left text-lg italic">&quot;{reference.quote}&quot;</p>
        <div className="mt-6 flex">
          <Image
            width={48}
            height={48}
            quality={100}
            src={reference.avatarUrl}
            alt={reference.name}
            className="mr-3 rounded-full"
          />
          <div>
            <p className="text-left font-bold">{reference.name}</p>
            <p className="text-left text-sm">{reference.company}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferenceCard;
